import { render, staticRenderFns } from "./sendCoupon.vue?vue&type=template&id=3cd6c65d&scoped=true&"
import script from "./sendCoupon.vue?vue&type=script&lang=js&"
export * from "./sendCoupon.vue?vue&type=script&lang=js&"
import style0 from "./sendCoupon.vue?vue&type=style&index=0&id=3cd6c65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd6c65d",
  null
  
)

export default component.exports